import React from 'react'
import { useTranslation } from 'react-i18next'
import InputField from '../../../../../component/formFields/InputField'
import SectionCard from '../shared/SectionCard'
import './style.css'

const EditKeywords = ({ formHandler, providerInfo ,isLoading}) => {
    const { t } = useTranslation()

    return (
        <SectionCard 
            title={t("keywords")} 
            icon="mdi:tag-multiple"
            className="edit-keywords"
        >
            <div className="edit-form-grid">
                <InputField 
                    isLoading={isLoading}
                    formHandler={formHandler} 
                    name={"searchKeywords"} 
                    defaultValue={providerInfo?.keywords}
                    isRequired={false}
                />
                <p className="helper-text">{t("keywords-hint")}</p>
            </div>
        </SectionCard>
    )
}

export default EditKeywords

